'use strict';

var homeVVS = function () {
  var dealerPageUrl = void 0;
  var _setDealerPageUrl = function _setDealerPageUrl(value) {
    return dealerPageUrl = value;
  },
      _getDealerPageUrl = function _getDealerPageUrl() {
    return dealerPageUrl;
  };
  var _init = function _init(codhost, url) {
    console.log('codhost received: ' + codhost);
    _setDealerPageUrl(url);
    $.ajax({
      url: '' + urlsVVS.api + codhost,
      dataType: 'json',
      success: function success(response) {
        console.log('response', response.dealersVehicles);
        var models = response.dealersVehicles;
        // const models = JSON.parse(dealersVehicles).dealersVehicles

        var sortedModels = _getSortedModels(models);
        console.log('sortedModels', sortedModels);
        _printVehiclesGrid(sortedModels);
      },
      error: function error(_error) {
        console.error(_error);
      }
    });
  };

  var _getSortedModels = function _getSortedModels(originalModels) {
    var referenceModels = ['leaf', 'nuevo juke', 'juke', 'qashqai', 'x-trail', 'micra', 'navara', 'nueva e-evalia', '370z', '370z roadster', 'gt-r'];
    var sortedModels = [];

    var _loop = function _loop(i) {
      originalModels.map(function (original, index) {
        if (original.vehicle.vdisplayModelo.toLowerCase() === referenceModels[i]) {
          sortedModels[i] = original;
          originalModels.splice(index, 1);
        }
      });
    };

    for (var i = 0; i < referenceModels.length; i++) {
      _loop(i);
    }

    sortedModels = sortedModels.filter(function (elem) {
      return elem !== null;
    });
    sortedModels = sortedModels.concat(originalModels);

    return sortedModels;
  };

  var _printVehiclesGrid = function _printVehiclesGrid(modelsArray) {
    $('.js-home-section-loading').addClass('hidden');
    var $gridContainer = $('.js-home-section').find('.js-list');
    for (var i = 0; i < modelsArray.length; i++) {
      var $modelBox = $(_template_grid(modelsArray[i]));
      $gridContainer.append($modelBox);
    }
  };

  /**
   * Returns the grid DOM's template filled with object model data
   * @param {String} model 
   */
  var _template_grid = function _template_grid(model) {
    var modelNameObj = utilsVVS.getDisplayModelName(model.vehicle.vdisplayModelo);
    var modelNewNode = modelNameObj.hasOwnProperty('new') ? '<span class="vvs-grid-vs-pretitle">' + modelNameObj.new + '</span>' : '';
    var modelUrl = _getDealerPageUrl() + '/vehiculos-stock/' + modelNameObj.urlName;
    var images = vehicleImg.getColorsAndImgs(model.vehicle, 'l', '335x165');
    var composedImage = '';
    for (var layer in images.urls) {
      composedImage += '<img class="img" alt="' + modelNameObj.name + '" src="https://configurador.nissan.es/' + images.urls[layer] + '" />';
    }
    return '\n      <div class="vvs-grid-vs_2-4cols">\n        ' + modelNewNode + '\n        <h3 class="vvs-grid-vs-h1"><a href="' + modelUrl + '" class="vvs-grid-vs-model model">' + modelNameObj.name + '</a></h3>\n        <span class="vvs-grid-vs-preprice">Desde</span>\n        <p class="vvs-grid-vs-price">' + utilsVVS.formatPrice(model.prices.precioOferta) + '\u20AC*</p>\n        <div class="vvs-grid-vs-fg">\n          <a href="' + modelUrl + '" title="' + modelNameObj.name + '" style="background-color: ' + model.vehicle.vhexadecimal + '" class="vvs-vehicle-image">\n            ' + composedImage + '\n          </a>\n        </div>\n      </div>\n    ';
  };

  return {
    init: _init
  };
}();